import AppConstants from '../Constants/AppConstants';

const SAFE_FIELDS = {
  feedback: ['feedBackSwitch', 'emailsString', 'selectedFeedbackType'],
  emailConfig: ['fromName', 'fromEmailAddress', 'logoImage'],
  orderNotification: ['valueArray'],
  emailNotificationEditor: ['subjectTitle', 'bodyValue', 'translations'],
  systemEmails: ['toggleValues'],
};

const sanitizeField = (panel, field, value) => {
  if (panel === 'emailConfig' && field === 'logoImage') {
    if (typeof value === 'string') return value;
    if (!value || typeof value !== 'object' || typeof value.base64 !== 'string' || value.base64.length > 900000) return undefined;
    const file = Array.isArray(value.fileList) ? value.fileList[0] : null;
    if (!file || typeof file.name !== 'string') return undefined;
    return {base64: value.base64, fileList: [{name: file.name, type: typeof file.type === 'string' ? file.type : ''}]};
  }
  if (panel.startsWith('emailNotificationEditor:') && field === 'translations') {
    if (!value || typeof value !== 'object' || Object.keys(value).length > 50) return undefined;
    const translations = {};
    for (const [language, fields] of Object.entries(value)) {
      if (!/^[a-zA-Z0-9_-]{1,16}$/.test(language) || !fields || typeof fields !== 'object') continue;
      const safeFields = {};
      for (const name of ['subject', 'body']) {
        if (typeof fields[name] === 'string' && fields[name].length <= 300000) safeFields[name] = fields[name];
      }
      translations[language] = safeFields;
    }
    const result = JSON.stringify(translations);
    return result.length <= 900000 ? translations : undefined;
  }
  if (Array.isArray(value) && value.length <= 100 && value.every(item => typeof item === 'string' || typeof item === 'boolean')) return value;
  return ['string', 'boolean', 'number'].includes(typeof value) ? value : undefined;
};

const storageKey = panel =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:communications:${panel}`;

export const readCommunicationDraft = panel => {
  const fields = SAFE_FIELDS[panel] || (/^emailNotificationEditor:[0-9]+$/.test(panel) ? SAFE_FIELDS.emailNotificationEditor : null);
  if (typeof window === 'undefined' || !fields) return {};
  try {
    const value = JSON.parse(window.localStorage.getItem(storageKey(panel)) || 'null');
    if (!value || typeof value !== 'object') return {};
    return Object.fromEntries(fields.map(field => [field, sanitizeField(panel, field, value[field])]).filter(([, fieldValue]) => fieldValue !== undefined));
  } catch (error) {
    return {};
  }
};

export const writeCommunicationDraft = (panel, values) => {
  const fields = SAFE_FIELDS[panel] || (/^emailNotificationEditor:[0-9]+$/.test(panel) ? SAFE_FIELDS.emailNotificationEditor : null);
  if (typeof window === 'undefined' || !fields) return;
  try {
    const safe = Object.fromEntries(fields.map(field => [field, sanitizeField(panel, field, values[field])]).filter(([, fieldValue]) => fieldValue !== undefined));
    window.localStorage.setItem(storageKey(panel), JSON.stringify(safe));
  } catch (error) {
    // Keep settings usable if browser storage is unavailable.
  }
};

export const clearCommunicationDraft = panel => {
  if (typeof window === 'undefined' || (!SAFE_FIELDS[panel] && !/^emailNotificationEditor:[0-9]+$/.test(panel))) return;
  try {
    window.localStorage.removeItem(storageKey(panel));
  } catch (error) {
    // Ignore storage errors after a successful save.
  }
};
